<div
  class="label-cell"
  [ngClass]="{ disabled: labelCellConfig.disabled, border: labelCellConfig.border, eyebrow: labelCellConfig.eyebrow }"
>
  <div *ngIf="labelCellConfig.leftIconName" class="label-cell-icon-left mr-xs">
    <bw-icon-legacy iconName="{{ labelCellConfig.leftIconName }}" color="{{ labelCellConfig.leftIconColor }}"></bw-icon-legacy>
  </div>
  <div class="label-cell-label-wrapper">
    <typography-legacy
      class="label-cell-subtitle"
      [ngClass]="{ 'text-medium-semibold': !labelCellConfig.eyebrow, 'text-xsmall-regular': labelCellConfig.eyebrow }"
      [color]="labelCellConfig.subtitleColor"
    >
      {{ labelCellConfig.subtitle }}
    </typography-legacy>
    <typography-legacy
      class="label-cell-title"
      [ngClass]="{ 'text-medium-semibold': labelCellConfig.eyebrow, 'text-xsmall-regular': !labelCellConfig.eyebrow }"
      [color]="labelCellConfig.titleColor"
    >
      {{ labelCellConfig.title }}
    </typography-legacy>
  </div>
  <div class="label-cell-icon">
    <typography-legacy class="text-medium-regular" color="var(--primary-text)" *ngIf="labelCellConfig.detail">{{
      labelCellConfig.detail
    }}</typography-legacy>
    <bw-icon-legacy iconName="chevron_right"></bw-icon-legacy>
  </div>
</div>
